// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRelationshipTypeDto
 */
export interface IRelationshipTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IRelationshipTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRelationshipTypeDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IRelationshipTypeDto interface.
 */
export function instanceOfIRelationshipTypeDto(value: object): value is IRelationshipTypeDto {
    return true;
}

export function IRelationshipTypeDtoFromJSON(json: any): IRelationshipTypeDto {
    return IRelationshipTypeDtoFromJSONTyped(json, false);
}

export function IRelationshipTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRelationshipTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IRelationshipTypeDtoToJSON(json: any): IRelationshipTypeDto {
    return IRelationshipTypeDtoToJSONTyped(json, false);
}

export function IRelationshipTypeDtoToJSONTyped(value?: IRelationshipTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

